import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  message,
  Icon,
  Typography,
  Alert
} from "antd";
import api from "../../../services/api";

const { Title, Text } = Typography;

const panelStyle = {
  borderRadius: 12,
  boxShadow: "0 12px 32px rgba(0,0,0,0.08)",
  border: "1px solid #f0f0f0",
  fontSize: 14,
  maxWidth: 600,
  margin: "0 auto",
  marginTop: 40
};

const ResetarSenha = props => {
  const { form, history, location } = props;
  const { getFieldDecorator } = form;
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (location.state && location.state.record && location.state.record.id) {
      setUser(location.state.record);
    } else {
      message.error("Nenhum usuário selecionado.");
      history.push("/user_list");
    }
  }, []);

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;

      if (values.password !== values.confirmPassword) {
        message.error("As senhas não coincidem.");
        return;
      }

      setLoading(true);
      try {
        await api.patch(`/pasta/users/${user.id}/`, {
          password: values.password
        });
        message.success("Senha alterada com sucesso!");
        history.push("/user_list");
      } catch (error) {
        console.error(error);
        message.error("Erro ao alterar senha. Verifique se atende aos requisitos.");
      } finally {
        setLoading(false);
      }
    });
  };

  if (!user) return null;

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <span style={{ display: "flex", alignItems: "center" }}>
            <Icon type="lock" style={{ marginRight: 8, color: "#faad14" }} />
            Alterar Senha
          </span>
        }
        style={panelStyle}
        headStyle={{ fontSize: 16, fontWeight: 700 }}
      >
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <Text type="secondary">Definindo nova senha para:</Text>
          <Title level={4} style={{ margin: "4px 0" }}>
            {user.nome || user.username}
          </Title>
          <Tag color="blue">{user.username}</Tag>
        </div>

        <Alert
          message="Requisitos de Segurança"
          description="A senha deve conter no mínimo 8 caracteres. Recomendamos usar letras maiúsculas, minúsculas e números."
          type="info"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Form layout="vertical" onSubmit={handleSubmit}>
          <Form.Item label="Nova Senha">
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "Informe a nova senha." },
                { min: 8, message: "A senha deve ter pelo menos 8 caracteres." }
              ]
            })(
              <Input.Password
                prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Nova senha"
                size="large"
              />
            )}
          </Form.Item>

          <Form.Item label="Confirmar Senha">
            {getFieldDecorator("confirmPassword", {
              rules: [{ required: true, message: "Confirme a nova senha." }]
            })(
              <Input.Password
                prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                placeholder="Repita a nova senha"
                size="large"
              />
            )}
          </Form.Item>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 24,
              gap: 8
            }}
          >
            <Button onClick={() => history.push("/user_list")} size="large">
              Cancelar
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon="check"
              size="large"
            >
              Salvar Senha
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

// Componente Tag dummy para evitar erro caso antd não exporte Tag dentro deste arquivo (já importado no topo)
const Tag = ({ color, children }) => (
  <span
    style={{
      backgroundColor: "#e6f7ff",
      color: "#1890ff",
      border: "1px solid #91d5ff",
      padding: "2px 8px",
      borderRadius: "4px",
      fontSize: "12px"
    }}
  >
    {children}
  </span>
);

export default Form.create({ name: "reset_password" })(ResetarSenha);



// WEBPACK FOOTER //
// ./src/pages/Usuario/components/form_senha.js